<template>
  <main class="page plain">
    <page-header title="全部到期" :subtitle="'共 ' + total + ' 位客户待跟进'" back @back="back">
      <button class="icon-button" :disabled="fetching || syncing" aria-label="刷新" @click="reloadList">
        <app-icon name="refresh" />
      </button>
    </page-header>
    <div class="list-filters below-header">
      <div class="chips">
        <button v-for="item in filters" :key="item.key" class="chip" :class="{ active: filter === item.key }" @click="filter = item.key">
          {{ item.label }}
        </button>
      </div>
    </div>
    <p v-if="syncError" class="error-message" role="status">{{ syncError }}<button class="text-button" @click="syncChangedCustomers">重试同步</button></p>
    <van-list v-model="loading" :finished="finished || !!error || syncing" @load="loadMore">
      <div v-if="shown.length" class="c-list" style="margin-top:12px">
        <customer-card v-for="item in shown" :key="item.id" :customer="item" @open="open" />
      </div>
    </van-list>
    <p v-if="error" class="error-message">
      {{ error }}
      <button class="text-button" @click="loadMore">重试</button>
    </p>
    <button v-if="!finished && !fetching && !error && !syncing" class="list-footer" @click="loadMore">加载更多到期客户</button>
    <div v-if="finished && !shown.length" class="empty-state">
      <app-icon name="check" />
      <strong>这一类没有待跟进的客户</strong>
      <p>保持节奏，客户的需求会更快得到回应。</p>
    </div>
    <p v-if="finished && shown.length" class="loading-state">已显示这一类的全部客户</p>
  </main>
</template>
<script>
import paged from '../../common/paged'
export default {
  mixins: [
    paged('/api/employee/remind/list', 'reminders', function() {
      return {}
    }, true)
  ],
  data() {
    const now = new Date()
    return {
      filter: 'all',
      today:
        now.getFullYear() +
        '-' +
        String(now.getMonth() + 1).padStart(2, '0') +
        '-' +
        String(now.getDate()).padStart(2, '0'),
      filters: [
        { key: 'all', label: '全部到期' },
        { key: 'overdue', label: '已逾期' },
        { key: 'today', label: '今天' }
      ]
    }
  },
  computed: {
    shown() {
      return this.list.filter(item => {
        const day = String(item.log_time || '').slice(0, 10)
        return (
          this.filter === 'all' ||
          (this.filter === 'overdue' ? day < this.today : day === this.today)
        )
      })
    }
  },
  methods: {
    back() {
      if (window.history.length > 1) this.$router.back()
      else this.$router.replace('/workbench')
    },
    open(item) {
      this.$router.push('/customer/detail/' + item.id + '/remind')
    },
    follow(item) {
      this.$router.push('/customer/edit/' + item.id + '/remind')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/remind/index.vue